<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>
          {{ $t('editPassword.passwordTitle') }}
          <span v-if="lang == 'zh'">{{ $t('common.required1') }}<i>*</i>{{ $t('common.required2') }}</span>
          <div v-else class="remark">{{ $t('common.required1') }}<i>*</i>{{ $t('common.required2') }}</div>
        </h3>
      </div>
      <div class="main">
        <div class="password_form">
          <el-form :model="getruleForm" status-icon :rules="setRules" ref="getruleForm" class="demo-getruleForm">
            <el-form-item :label="$t('editPassword.originPassword')" prop="oldPass">
              <el-input type="password" :placeholder="$t('editPassword.placeholder')" v-model="getruleForm.oldPass"></el-input>
            </el-form-item>

            <el-form-item :label="$t('editPassword.newPassword')" prop="newPass">
              <el-input type="password" :placeholder="$t('editPassword.placeholder')" v-model="getruleForm.newPass"></el-input>
            </el-form-item>

            <el-form-item :label="$t('editPassword.confimPassword')" prop="surePass">
              <el-input type="password" :placeholder="$t('editPassword.placeholder')" v-model="getruleForm.surePass"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm('getruleForm')"> {{ $t('common.submit') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { verifyOld, modifyPassword } from '../../../../../api/password.js';
import MobileHead from '../../../comment/mobile/mobileHead.vue';
export default {
  name: 'verifyPassword',
  data() {
    return {
      getruleForm: {
        oldPass: '',
        newPass: '',
        surePass: '',
      },
      lang: '',
    };
  },
  components: {
    MobileHead,
  },
  created() {
    this.lang = localStorage.getItem('lang');
  },
  computed: {
    setRules() {
      var validateSurePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('editPassword.placeholder')));
        } else if (value !== this.getruleForm.newPass) {
          callback(new Error(this.$t('editPassword.placeholder1')));
        } else {
          callback();
        }
      };
      return {
        oldPass: [
          {
            message: this.$t('editPassword.placeholder'),
            trigger: 'blur',
            required: 'true',
          },
        ],
        newPass: [
          {
            message: this.$t('editPassword.placeholder'),
            trigger: 'blur',
            required: 'true',
          },
        ],
        surePass: [{ validator: validateSurePass, trigger: 'blur', required: 'true' }],
      };
    },
  },

  methods: {
    //验证原密码
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = { oldPassword: this.getruleForm.oldPass };
          try {
            const { data } = await verifyOld(params);

            if (data.code != 200) {
              this.$message({ type: 'error', message: '原密码验证失败!' });
            } else {
              console.log('-------');
              //调用方法进行请求
              this.setsubmitForm();
            }
          } catch (e) {}
        }
      });
    },

    async setsubmitForm() {
      //修改密码逻辑
      const params = { newPassword: this.getruleForm.surePass };
      try {
        const { data } = await modifyPassword(params);
        console.log('****', data);
        if (data.code === 200) {
          this.$message({
            type: 'success',
            message: '登录密码修改成功!',
          });
          this.$router.push({ name: 'adminLogin' });
        } else {
          this.$message({ type: 'error', message: '密码修改失败!' });
        }
      } catch (err) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  font-family: PingFangSC-Medium, PingFang SC;
  padding: 2.6vw 10px;
  background: #f0f2f5;
  height: 100vh;
  .header {
    padding: 0 0 5.3vw 0px;
    border-bottom: 1px solid #e8e8e8;

    h3 {
      font-size: 5.3vw;
      font-weight: 600;
      color: #333333;
      line-height: 7.47vw;
      span {
        margin-left: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
      .remark {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
    }
  }

  .main {
    // margin: 40px 30px 0;
    display: flex;
    // flex-direction: column;
    // align-items: center;
    height: calc(100vh - 260px);
    //步骤条
    .step {
      font-size: 4.3vw;
      display: flex;
      justify-content: center;
      align-items: center;

      .line {
        width: 192px;
        height: 1px;
        background: #e9e9e9;
        margin: 0 20px;
      }

      .step_one,
      .step_two {
        display: flex;
        align-items: center;
      }
      .step_one {
        color: #333333;
        font-weight: 500;
      }
      .step_two {
        color: #999999;
        font-weight: 400;
      }

      .circle {
        border-radius: 50%;
        height: 32px;
        width: 32px;
        display: inline-block;
        vertical-align: top;
        margin-right: 10px;
        span {
          display: block;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 16px;
          font-family: HelveticaNeue;
        }

        &.active {
          background: #006fb8;
          color: #ffffff;
        }

        &.hollow {
          border: 1px solid rgba(0, 0, 0, 0.15);
          color: rgba(0, 0, 0, 0.25);
        }
      }
    }
    .password_form {
      // margin-top: 40px;
    }
  }
}
</style>

<style scoped>
.el-form-item__content >>> .el-form-item__error {
  top: 0px !important;
}
.body >>> .el-card__body {
  padding: 9px;
}

.password_form >>> .el-form-item {
  margin-bottom: 0px !important;
  margin-top: 18px;
}

.el-card_ >>> .el-card__body {
  /* padding: 9px !important; */
  height: 500px;
}

.password_form >>> .el-input {
  width: 92vw;
}
.password_form >>> .el-input__inner {
  width: 92%;
  height: 32px;
  line-height: 32px;
}
.password_form >>> .el-button {
  background-color: #006fb8;
  color: #ffffff;
  width: 92%;
  height: 32px;
  padding: 0;
  font-weight: 400;
}
</style>
